import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

/**
 * The Overview tab body (SWOOP-154), rendered inside the vehicle-profile layout at
 * `/vehicles/$vehicleId/overview`. Permission gating (`vehicles:list`) is inherited from the layout
 * route's `beforeLoad`.
 */
export const Route = createFileRoute('/_authenticated/vehicles_/$vehicleId_/overview/')({
  component: lazyRouteComponent(() => import('&/features/vehicles/pages/vehicle-overview-page')),
  staticData: { titleKey: 'vehicleOverview' },
});
